"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GlobalMiddleware", {
    enumerable: true,
    get: function() {
        return GlobalMiddleware;
    }
});
const _common = require("@nestjs/common");
const _config = require("@nestjs/config");
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let GlobalMiddleware = class GlobalMiddleware {
    use(req, res, next) {
        var _Noco_config_envs_Noco_env, _Noco_config_envs, _Noco_config, _Noco_config1;
        req.ncSiteUrl = ((_Noco_config = _Noco.default.config) == null ? void 0 : (_Noco_config_envs = _Noco_config.envs) == null ? void 0 : (_Noco_config_envs_Noco_env = _Noco_config_envs[_Noco.default.env]) == null ? void 0 : _Noco_config_envs_Noco_env.publicUrl) || ((_Noco_config1 = _Noco.default.config) == null ? void 0 : _Noco_config1.publicUrl) || req.protocol + '://' + req.get('host');
        req.ncFullUrl = req.protocol + '://' + req.get('host') + req.originalUrl;
        const dashboardPath = this.config.get('dashboardPath', {
            infer: true
        });
        // used for playwright tests so env is not documented
        req.dashboardUrl = process.env.NC_DASHBOARD_URL || req.ncSiteUrl + dashboardPath;
        next();
    }
    constructor(config){
        this.config = config;
    }
};
GlobalMiddleware = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.ConfigService === "undefined" ? Object : _config.ConfigService
    ])
], GlobalMiddleware);
